/** 智慧无限方案已接入的 keyboardType 列表 */
export const ZHWX_KEYBOARD_TYPES = ["dk87", "dk75Single"] as const;

export type ZhwxKeyboardType = (typeof ZHWX_KEYBOARD_TYPES)[number];

/** 是否为智慧无限键盘型号（按 keyboardType 判断） */
export function isZhwxKeyboardType(
  keyboardType?: string | null
): keyboardType is ZhwxKeyboardType {
  const kt = String(keyboardType ?? "");
  return kt === "dk87" || kt === "dk75Single";
}

/** 是否支持 Win Fn 改键层（DK75 Single 公版仅默认层） */
export function isZhwxFnLayerSupported(keyboardType?: string | null): boolean {
  return isZhwxKeyboardType(keyboardType) && keyboardType !== "dk75Single";
}

/** 性能页是否展示背光关闭 / 2.4G 休眠（DK75 Single 仅全局无冲 + Win 锁） */
export function supportsZhwxBacklightSleepPerf(
  keyboardType?: string | null
): boolean {
  return String(keyboardType ?? "") !== "dk75Single";
}

/** 智慧无限是否支持在线固件升级（当前均无固件库） */
export function supportsZhwxFirmwareOnlineUpdate(
  _keyboardType?: string | null
): boolean {
  return false;
}

/** 神光同步 / 全局音乐律动：智慧无限全系（含 DK87、DK75 Single）暂不支持 */
export function supportsZhwxSyncRgb(_keyboardType?: string | null): boolean {
  return false;
}
